import { Box, styled as styledMui } from '@mui/material';

const DataGridBox = styledMui(Box)(({ theme }) => ({
  height: '70vh',
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  border: `1px ${theme.palette.mode === 'dark' ? '#222833' : '#e6e8ed'} solid`,
  borderRadius: '8px',
}));

export default DataGridBox;
